module.exports = __webpack_public_path__ + "img/home_course_grey.dc003421.png";